import React, { FunctionComponent, useMemo } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import BackdropImage, { BackdropImageProps } from '../../../BackdropImage';

const useStyles = () => {
  const { breakpoint, spacing } = useTheme();

  return useMemo(() => {
    return {
      root: {
        position: 'relative',
        flex: `1 1 50%`,
        width: '100%',
        maxWidth: `calc(100% - ${spacing(6)})`,
        [breakpoint.up('md')]: {
          maxWidth: `calc(50% - ${spacing(12)})`,
        },
      },
      image: {
        flex: 1,
        minWidth: '100%',
        [breakpoint.up('md')]: {
          borderRadius: spacing(2),
          overflow: 'hidden',
        },
      },
    } as const;
  }, [breakpoint, spacing]);
};

export interface ImageProps extends BackdropImageProps {
  title?: string;
  children?: React.ReactNode;
}

const Image: FunctionComponent<ImageProps> = (props) => {
  const { title, ...other } = props;
  const classes = useStyles();

  return (
    <Flex css={classes.root}>
      <BackdropImage hideOverlay={!title} aspectRatio={1.4} css={classes.image} {...other}>
        {title ? (
          <Text variant="headline1" as="h2">
            {title}
          </Text>
        ) : null}
      </BackdropImage>
    </Flex>
  );
};

export default Image;
